import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormInputBase} from '../model/form-input-base';
import {Observable, Subject, Subscription} from 'rxjs';
import {debounceTime, switchMap, startWith} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {KeyValueDto} from '../../../../@services/gen';
import {NgMaterialFormService} from '../service/ng-material-form.service';
import {DatePipe} from '@angular/common';
import {MatSelect} from '@angular/material/select';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.css'],
})
export class FormInputComponent implements OnInit {
  @Input() field: FormInputBase<string | boolean>;
  @Input() form: FormGroup;

  loadingAutocomplete = false;
  autocompleteList;
  subjectAutocomplete = new Subject();
  subs: Subscription[] = [];

  selectedDateRangeButton: string;
  selectedDateRange: {start: Date; end: Date; dateOptionSelect: String};

  ngOnInit(): void {
    if (this.field.controlType == 'autocomplete') {
      this.getAutocomplete();
    }

    if (this.field.controlType == 'dropdown' && this.field.api != null) {
      this.subscribeOptionsApi();
    }

    if (this.field.controlType == 'dropdown-select' && this.field.api != null) {
      this.subscribeOptionsApi();
    }

    if (this.field.controlType == 'dropdown' && this.field.value == null) {
      this.form.get(this.field.key).setValue('all');
    }

    if (this.field.controlType == 'daterange') {
      if (typeof this.field.value === 'undefined') {
        this.selectedDateRangeButton = 'today';
        this.selectedDateRange = this.ngMaterialFormService.getRangeFromValue(this.selectedDateRangeButton);
        this.form.get(this.field.key).setValue(this.selectedDateRange);
      } else if (this.field.value && typeof this.field.value === 'string') {
        this.selectedDateRangeButton = this.field.value;
        this.selectedDateRange = this.ngMaterialFormService.getRangeFromValue(this.selectedDateRangeButton);
        this.form.get(this.field.key).setValue(this.selectedDateRange);
      } else {
        if (this.field.value?.dateOptionSelect != 'custom') {
          console.log(this.field.value?.dateOptionSelect);
          this.selectedDateRangeButton = this.field.value ? this.field.value?.dateOptionSelect : 'today';
          this.selectedDateRange = this.ngMaterialFormService.getRangeFromValue(this.selectedDateRangeButton);
          this.form.get(this.field.key).setValue(this.selectedDateRange);
        } else {
          this.selectedDateRangeButton = this.field.value?.dateOptionSelect;

          this.selectedDateRange = {
            start: new Date(this.field.value?.start),
            end: new Date(this.field.value?.end),
            dateOptionSelect: this.field.value?.dateOptionSelect,
          };

          this.form.get(this.field.key).setValue(this.selectedDateRange);
        }
      }
    }
  }
  constructor(
    private http: HttpClient,
    private ngMaterialFormService: NgMaterialFormService,
    private datePipe: DatePipe,
    private select: MatSelect
  ) {}

  hasFieldError(): boolean {
    return (
      this.form.get(this.field.key).invalid &&
      (this.form.get(this.field.key).dirty || this.form.get(this.field.key).touched)
    );
  }

  searchAutocomplete(event) {
    this.loadingAutocomplete = true;
    this.autocompleteList = [];
    this.subjectAutocomplete.next(event.target.value);
  }

  changeAutocomplete(data: any, key: any, evt?: any) {
    if (!evt || evt.isUserInput) {
      this.form.get(key).setValue(data.value);
    }
  }

  getAutocomplete(): any {
    this.subs.push(
      this.subjectAutocomplete
        .pipe(
          startWith(''),
          debounceTime(400),
          switchMap((val: string) => {
            return this.loadData(this.field.serviceConfig.api, val);
          })
        )
        .subscribe((content) => {
          if (content) {
            this.autocompleteList = content;
          }

          this.loadingAutocomplete = false;
        })
    );
  }

  loadData(url, search: string): Observable<any[]> {
    const params = {
      searchTerm: search ? search : null,
      dateStart: this.selectedDateRange ? this.selectedDateRange.start : null,
      dateEnd: this.selectedDateRange ? this.selectedDateRange.end : null,
    };

    return this.http.post<any>(url, params);
  }

  convertNumber(key) {
    if (isNaN(key)) {
      return key;
    } else {
      return +key;
    }
  }
  subscribeOptionsApi() {
    if (this.field.api) {
      this.getOptionsApi().subscribe((x: KeyValueDto[]) => {
        this.field.options = x;
      });
    }
  }
  getOptionsApi(): Observable<any> {
    let command = {
      searchTerm: '',
    };

    command = Object.assign({}, command, this.field.params);
    return this.http.post<KeyValueDto[]>(this.field.api, command);
  }

  // Mat Date Range
  onButtonDateRangeChange(value) {
    this.selectedDateRangeButton = value;
    this.updateDateRange();
  }

  updateDateRange() {
    // Update the selectedRange based on the selectedButton
    this.selectedDateRange = this.ngMaterialFormService.getRangeFromValue(this.selectedDateRangeButton);

    this.form.get(this.field.key).setValue(this.selectedDateRange);
  }

  customStartDate: Date = null;
  customEndDate: Date = null;

  dateChange(type, event): void {
    // console.log(event);
    // if (type === 'start') {
    //   this.customStartDate = event.value;
    // } else {
    //   this.customEndDate = event.value;
    // }

    this.selectedDateRangeButton = 'custom';

    this.updateSelectedDateRange();
  }

  updateSelectedDateRange(): void {
    this.selectedDateRangeButton = 'custom';
    if (this.selectedDateRange.start && this.selectedDateRange.end) {
      this.selectedDateRange = this.ngMaterialFormService.getRangeFromValue(
        this.selectedDateRangeButton,
        this.selectedDateRange.start,
        this.selectedDateRange.end
      );

      this.form.get(this.field.key).setValue(this.selectedDateRange);
    }
  }

  selectAll(key) {
    const allOptionValues = this.field.options.map((opt) => this.convertNumber(opt.key));
    const currentValues = this.form.get(key).value;

    if (!this.isAllSelected(key)) {
      const updatedValues = [...currentValues, ...allOptionValues];
      this.form.get(key).patchValue(updatedValues);
    } else {
      const updatedValues = currentValues.filter((value) => !allOptionValues.includes(value));
      this.form.get(key).patchValue(updatedValues);
    }
  }

  isAllSelected(key) {
    const selectedValues = this.form.get(key).value;
    const allOptionValues = this.field.options.map((opt) => this.convertNumber(opt.key));

    return selectedValues && selectedValues.length === allOptionValues.length;
  }
}
